import Navbar from './components/Navbar';
import Hero from './components/Hero';
import TodayUpdates from './components/TodayUpdates';
import HotRanking from './components/HotRanking';
import EditorPicks from './components/EditorPicks';
import NewReleases from './components/NewReleases';
import HighScores from './components/HighScores';
import PopularSerials from './components/PopularSerials';
import FAQ from './components/FAQ';
import CTA from './components/CTA';
import Footer from './components/Footer';
import BackToTop from './components/BackToTop';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      <Navbar />
      <main>
        <Hero />
        <TodayUpdates />
        <HotRanking />
        <EditorPicks />
        <NewReleases />
        <HighScores />
        <PopularSerials />
        <CTA />
        <FAQ />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}